import { Injectable } from '@angular/core';
import { AuthData } from './auth';
import { GlobalConfig } from '../app/app.config';
import { Database } from '../providers/database';
import { Utilities } from '../providers/utilities';
import * as firebase from 'firebase';

@Injectable()
export class Tracking {

  constructor(public auth: AuthData, public db: Database, public ut: Utilities) {
  }

  setLogout() {
    return new Promise((resolve, reject) => {
      console.log('Cerrando sesion');

      if (!GlobalConfig._debugMode) {
        // TODO: Tracking para logout
        resolve(true);
      } else {
        resolve(true);
      }
    });
  }

  trackError(child, error) {
    // let tmp: any;
    // tmp.error = JSON.stringify(error);
    // tmp.uid = this.auth.getUser().uid;
    // tmp.email = this.auth.getUser().email || 'Anonymous';
    // tmp.timestamp = new Date().getTime();

    // return this.db.pushData('/___errors/' + child, tmp);

  }

  saveTrackingResource(client: any, tokenEvent: string, speakerId: string, resourceId: string) {
    let postData = {
      tokenEvent: tokenEvent,
      speakerId: speakerId,
      platform: this.ut.getPlatformData(),
      timestamp: new Date().getTime(),
      email: this.auth.getUser().email || 'Anonymous',
      uid: this.auth.getUser().uid,
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___trackingResource', postData)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Speakers/' + speakerId + '/Resources/' + resourceId + '/numViews').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch(error => {
        console.log(error)
        reject(error);
      });
    })
  }

  saveTrackingSponsor(client: any, tokenEvent: string, sponsorId: string) {
    let postData = {
      tokenEvent: tokenEvent,
      sponsorId: sponsorId,
      platform: this.ut.getPlatformData(),
      timestamp: new Date().getTime(),
      email: this.auth.getUser().email || 'Anonymous',
      uid: this.auth.getUser().uid,
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___trackingSponsor', postData)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Sponsors/' + sponsorId + '/numClicks').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch(error => {
        console.log(error)
        reject(error);
      });
    })
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/tracking.ts